(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scc-product-showcase"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-scc-quick-view-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.sccQuickViewOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-scc-quick-view-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    const sizeButton = event.target.closest('[data-scc-fixture-size]');
    if (sizeButton) {
      const group = sizeButton.parentElement;
      group.querySelectorAll('[data-scc-fixture-size]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      sizeButton.setAttribute('aria-pressed', 'true');
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.matches('dialog.scc-fixture-dialog')) event.target.close();
  });

  } catch(e) { console.error(e); }
})();
})();
